/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPatchRequest
 */
export interface UserPatchRequest {
    /**
     * The email address of the user.
     * @type {string}
     * @memberof UserPatchRequest
     */
    email?: string | null;
    /**
     * The role assigned to the user. OWNER or USER
     * @type {string}
     * @memberof UserPatchRequest
     */
    role?: string | null;
    /**
     * The first name of the user.
     * @type {string}
     * @memberof UserPatchRequest
     */
    firstname?: string | null;
    /**
     * The last name of the user.
     * @type {string}
     * @memberof UserPatchRequest
     */
    lastname?: string | null;
}

/**
 * Check if a given object implements the UserPatchRequest interface.
 */
export function instanceOfUserPatchRequest(value: object): value is UserPatchRequest {
    return true;
}

export function UserPatchRequestFromJSON(json: any): UserPatchRequest {
    return UserPatchRequestFromJSONTyped(json, false);
}

export function UserPatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'role': json['role'] == null ? undefined : json['role'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
    };
}

export function UserPatchRequestToJSON(json: any): UserPatchRequest {
    return UserPatchRequestToJSONTyped(json, false);
}

export function UserPatchRequestToJSONTyped(value?: UserPatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'role': value['role'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
    };
}

